import React from 'react';
import { Link } from 'react-router-dom';
import { attachSeries } from '../../../utils/product';

const STYLE = {
  display: 'flex',
  flexDirection: 'row',
  marginBottom: '8px',
  borderRadius: '4px',
  padding: '8px',
  background: '#f5f5f5',
};

export default function Index({ data }) {
  return (
    <Link to={`/post/${data.post_id}`} style={STYLE}>
      <div style={{ width: '70px', height: '70px', background: '#f0f0f0', borderRadius: '2px' }}>
        <img src={data.media} alt={data.post_id} width={70} style={{ borderRadius: '2px' }} />
      </div>
      <div className={'mr-16p f-row align-items-center'} style={{ fontWeight: 'bold', color: '#262626' }}>
        {attachSeries(data.id, data.series)}
      </div>
    </Link>
  );
}
